import ClaimContainer from "./ClaimContainer";

export default ClaimContainer;